export default __webpack_public_path__ + "static/media/react.81ed438b.png";